export const POSTHOG_INIT = {
  KEY: 'phc_oH4DuD23KbLYXRheBe6RqWo9I6mXhYsBow8DUHueWh5',
  API_HOST: 'https://eu.i.posthog.com',
  DEFAULTS: '2025-05-24',
};
